export default [
    { class: "flag-icon flag-icon-br", text: "Português (BR)", value: "br" },
    { class: "flag-icon flag-icon-es", text: "Español", value: "es" },
    { class: "flag-icon flag-icon-um", text: "English", value: "en" },
]